import { makeStyles, createStyles } from '@material-ui/core/styles';

const loaderStyle = makeStyles(() =>
  createStyles({
    loaderWrapper: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      position: 'fixed',
      top: '0',
      left: '0',
      bottom: '0',
      right: '0',
      background: 'rgba(0, 0, 0, 0.72)',
      zIndex: 99999,
    },
    progress: {
      position: 'fixed',
      top: '50%',
      left: '50%',
    },
  })
);

export default loaderStyle;
